import { CustomerComponents } from "@services/companyApi";
import { Space } from "antd";
import CustomerCard from "./CustomerCard";
import { useFormContext } from "react-hook-form";
import { CustomerAddresses } from "./customerAddresses";
import { CustomerManagement } from "./customerManagement";
import { CustomerStaff } from "./customerStaff";
import { CustomerBankAccounts } from "./customerBankAccounts";
import { CustomerFoundersOrgs } from "./customerFoundersOrgs";
import { CustomerPersons } from "./customerPersons";
import CustomerContacts from "./CustomerContacts";

export interface BaseQuestinnaireProps {
  prefix: string;
}

export const CustomerQuestionnaire = () => {
  const { getValues } = useFormContext();

  return (
    <Space direction="vertical" size={24} style={{ width: '100%', display: 'flex' }}>
      {getValues("customerCard") && <CustomerCard prefix="customerCard" />}
      {getValues("customerAddresses") && <CustomerAddresses prefix="customerAddresses" />}
      {getValues("customerManagement") && <CustomerManagement prefix="customerManagement" />}
      {getValues("customerStaff") && <CustomerStaff prefix="customerStaff" />}
      {getValues("customerBankAccounts") && <CustomerBankAccounts prefix="customerBankAccounts" />}
      {getValues("customerFounderOrgs") && <CustomerFoundersOrgs prefix="customerFounderOrgs" />}
      {getValues("customerPersons") && <CustomerPersons prefix="customerPersons" />}
      {getValues("principalContacts") && <CustomerContacts prefix="principalContacts" />}
      
    </Space>
  )
};
